@import url("./common/assets/xoops.css");
@import url("./common/assets/theme/style.css");
